import CountCell from 'components/CountCell';
import type { ManagedFleet } from '../..';

interface DepotsCellProps {
  rowData: ManagedFleet;
}

export default function DepotsCell({
  rowData: { id, totals, sentinelTeam },
}: DepotsCellProps) {
  return (
    <CountCell
      count={totals?.enabledAssetGroupingsCount}
      pageParams={{
        tab: 'depots',
        accountIds: [id],
        teamIds: [sentinelTeam.id],
        oemSegmentIds: sentinelTeam.oemSegment?.id
          ? [sentinelTeam.oemSegment?.id]
          : [],
        depotIds: [],
      }}
    />
  );
}
